export const ANIMAL_TABLE_TEMPLATE = [
  "48px",                 // Küpe No
  "58px",                 // Sipariş No
  "70px",                 // Büyükbaş / Küçükbaş
  "72px",                 // Hisseli
  "78px",                 // Satış Durumu
  "minmax(170px,1fr)",    // Müşteri - kalan boşluğu alan ana kolon
  "76px",                 // KG/REF
  "84px",                 // Satış
  "76px",                 // Ödenen
  "82px",                 // Kalan
  "78px",                 // Kesim Günü
  "52px",                 // Taşıma
  "90px",                 // Kesim Durumu
  "88px",                 // Kesime Uygun
  "94px",                 // Ödeme Durumu
  "82px",                 // Tamamlanan
  "126px",                // İşlem
].join(" ");

export const ANIMAL_TABLE_GRID = ANIMAL_TABLE_TEMPLATE;

// Sabit veri kolonları dar kalır; kalan genişlik Müşteri kolonuna akar.
export const ANIMAL_TABLE_MIN_WIDTH = 1508;
